import React from 'react';
import { Snackbar, Alert, Button } from '@mui/material';
import useAppVersionCheck from '../hooks/useAppVersionCheck';

// Mounted from src/index.js beside <App />, so it runs on every route, signed in or not.
// Top-center keeps it clear of the bottom-anchored page toasts and the action bars they sit over.
const AppVersionNotice = (props) => {
    const { updateAvailable, reload } = useAppVersionCheck(props);

    return (
        <Snackbar open={updateAvailable} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
            <Alert
                severity="info"
                variant="filled"
                action={(
                    <Button color="inherit" size="small" onClick={reload}>
                        Reload
                    </Button>
                )}
                sx={{ alignItems: 'center', borderRadius: 2, boxShadow: '0 8px 32px rgba(0,0,0,0.12)' }}
            >
                New version available
            </Alert>
        </Snackbar>
    );
};

export default AppVersionNotice;
